import React from "react";
import "../../styles/Accordion.css"
import AllertIscrizione from "../multitessere/AllertIscrizione";
import SpaceL from "../../commons/SpaceL";

function RunAccordionPrezzi() {
    return (
        <div className="accordion d-flex flex-column m-auto" id="accordionFlushExample" style={{maxWidth: "50em"}}>
            <div className="accordion-item">
                <h2 className="accordion-header d-flex flex-row" id="headingOne"
                    style={{justifyContent: "center", textAlign: "center"}}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        PREZZI
                    </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne"
                     data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{width: "30em"}}>
                                <thead >
                                <tr >
                                    <th scope="col" style={{width: "15%"}}>
                                        1 mese
                                    </th>
                                    <th scope="col" style={{width: "15%"}}>
                                        3 mesi
                                    </th>
                                    <th scope="col" style={{width: "15%"}}>
                                        6 mesi
                                    </th>
                                    <th scope="col" style={{width: "15%"}}>
                                        11 mesi
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <td className={"data-cell"}>85 €</td>
                                    <td className={"data-cell"}>229€</td>
                                    <td className={"data-cell"}>390€</td>
                                    <td className={"data-cell"}>654€</td>
                                </tr>
                                </tbody>
                            </table>
                            <br/>
                            <table className="table text-center m-auto" style={{width: "10em"}}>
                                <thead >
                                <tr >
                                    <th scope="col">
                                        11 ingressi
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <td className={"data-cell"}>85 €</td>
                                </tr>
                                </tbody>
                            </table>
                            <SpaceL />
                             <AllertIscrizione />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RunAccordionPrezzi